import axios from "axios";
import { ADDERS_CATEGORIES_API, MAIN_URL } from "../../API/Api";

const GetAllAddersCategories = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    let response = await axios({
        method: "GET",
        baseURL: `${ADDERS_CATEGORIES_API}/group-list`,
        headers: headers,
        params: { ...data },
    });

    return response.data;
};

const GetAllCategoriesChildrens = async (group_id, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    let response = await axios({
        method: "GET",
        baseURL: `${ADDERS_CATEGORIES_API}/${group_id}/get-group`,
        headers: headers,
    });

    return response.data;
};

const GetSingleGroupList = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    let response = await axios({
        method: "GET",
        baseURL: `${ADDERS_CATEGORIES_API}/${data}`,
        headers: headers,
    });
    return response.data;
};

const CreateAdderCategory = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    let response = await axios({
        method: "POST",
        baseURL: `${ADDERS_CATEGORIES_API}/create-group`,
        headers: headers,
        data,
    });
    return response.data;
};

const CreateCategoryChildren = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    let response = await axios({
        method: "POST",
        baseURL: `${ADDERS_CATEGORIES_API}/add-group-members`,
        headers: headers,
        data,
    });
    return response.data;
};

const UpdateAdderCategory = async (data, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    let response = await axios({
        method: "POST",
        baseURL: `${ADDERS_CATEGORIES_API}/${data.id}/edit`,
        headers: headers,
        data,
    });
    return response.data;
};

const DeleteAddreGroupCategory = async (id, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    let response = await axios({
        method: "POST",
        baseURL: `${ADDERS_CATEGORIES_API}/${id}/group-delete`,
        headers: headers,
    });
    return response.data;
};

const DeleteAddreGroupMembersCategory = async (id, token) => {
    let headers = {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };
    let response = await axios({
        method: "POST",
        baseURL: `${ADDERS_CATEGORIES_API}/remove-group-members`,
        data: `member_id=${id}`,
        headers: headers,
    });
    return response.data;
};

const AddersCategoriesService = {
    GetAllAddersCategories,
    GetAllCategoriesChildrens,
    GetSingleGroupList,
    CreateAdderCategory,
    CreateCategoryChildren,
    UpdateAdderCategory,
    DeleteAddreGroupCategory,
    DeleteAddreGroupMembersCategory,
};

export default AddersCategoriesService;
